<div class="default-theme">
    <nav class="navbar navbar-expand-lg ">
        <div class="container-fluid p-0">
            <!-- Brand -->
        <div id="ctl_straviso_logo_div" class="brand_name_div tooltip_custom">
            <a class="navbar-brand">
                <img src="../../../../assets/img/myTaskEasy_logo_updated.png" alt="Logo" class="head-logo" (click)="gotoDashboard()"
                    style="cursor: pointer;">
            </a>
        </div>
        <!-- Toggler/collapsibe Button -->
        <button class="navbar-toggler toggleIconNavbar" type="button" data-toggle="collapse" data-target="#collapsibleNavbar" style="outline: hidden;">
            <img class="profileImg" [src]="bussinessLogo? bussinessLogo:'../../../../assets/img/noBLogo.png'" alt="" style="width: 40px; position: absolute; right: 334px;">
            <span class="businessNameMobile">{{bussinessData?.businessName}}</span>
            <span class="businessIdLabelMobile">Business ID:</span>
            <span class="businessIdMobile">{{bussinessData?.businessId}}</span>
            <span class="business dateDivMobile">
                <span class="dateDiv">
                    <p id="date">{{todayDate | date: 'dd'}}</p>
                </span>
                <div class="idDate">
                    <p class="idDateValue dateValueMobile">
                        {{todayDate | date: 'MMMM'}}</p>
                    <p class="idDateDay">
                        {{todayDate | date: 'EEEE'}}
                    </p>
                </div>
            </span>
            <i class="pi pi-align-justify" style="color: white;font-size: 35px;margin-right: 82px;margin-top: 5px;" (click)="op1.toggle($event)"></i> 
            <a class="nav-link name userNameMobile">{{userPData?.firstname}}</a>
            <img class="profileImg pointer profileImageMobile" [src]="profileSrc? profileSrc:'../../../assets/img/profile.jpg'"
                    alt="" (click)="opProfile.toggle($event)" style="width: 40px;position: absolute;right: 11px;">    
        </button>
        <p-overlayPanel #op1  class="nine-dots-overlay" [dismissable]="true" #nine>
            <div class='row' *ngIf="!adminNinedot">
                <div class="onedot col-4 p-0" (click)="gotoDashboard();op1.hide();">
                    <a class="nav-link newCssLink" routerLinkActive="link-active" style="text-align: center;" pTooltip="{{'home' | translate}}">
                        <img src="../../../../assets/img/logos/home.png" class="nineImg newImg">
                        <div class="newSpan">{{'home' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0" (click)="gotoReport()">
                    <a class="nav-link newCssLink" (click)="op1.hide();" style="text-align: center;" pTooltip="{{'reports' | translate}}">
                        <img src="../../../../assets/img/logos/reports.png" class="nineImg newImg">
                        <div class="newSpan">{{'reports' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0" (click)="gotoAdmin($event,op1)" *ngIf="isadmin">
                    <a class="nav-link newCssLink" routerLinkActive="link-active" style="text-align: center; " pTooltip="{{'admin' | translate}}">
                        <img src="../../../../assets/img/logos/admin.png" class="nineImg newImg">
                        <div class="newSpan">{{'admin' | translate}}</div>
                    </a>
                </div>
                
                <div class="onedot col-4 p-0" *ngIf="!isadmin"  >
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/admin-list" style="text-align: center; " pTooltip="{{'list' | translate}}">
                        <img src="../../../../assets/img/logos/list.png" class="nineImg newImg">
                        <div class="newSpan">{{'list' | translate}}</div>
                    </a>
                </div>
            </div>
            <div class='row' *ngIf="!adminNinedot" >
                <div class="onedot col-4 p-0" (click)="openFPFormHelp('help','right')" >
                    <a class="nav-link newCssLink"  (click)="op1.hide();" routerLinkActive="link-active" pTooltip="{{'hELP' | translate}}"
                        style="text-align: center;background: #6E7F91 !important;">
                       <img src="../../../../assets/img/logos/help.png" class="nineImg newImg">
                       <div class="newSpan">{{'hELP' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0" (click)="openFPFormHelp('FAQ','right')">
                    <a class="nav-link newCssLink" (click)="op1.hide();" style="text-align: center;background: #6E7F91 !important;" pTooltip="{{'fAQs' | translate}}">
                        <img src="../../../../assets/img/logos/faq.png" class="nineImg newImg">
                        <div class="newSpan">{{'fAQs' | translate}}</div>    
                    </a>
                </div>
                <div class="onedot col-4 p-0" (click)="opendisplayContactSupport()">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLinkActive="link-active" pTooltip="{{'contactSupport' | translate}}"
                        style="text-align: center; background: #6E7F91 !important;">
                        <img src="../../../../assets/img/logos/support.png" class="nineImg newImg">
                        <div class="newSpan">{{'contactSupport' | translate}}</div>  
                    </a>
                </div>



            </div>
            <div class='row' *ngIf="!adminNinedot">
                <div class="onedot col-4 p-0" (click)="openFPFormFeedback()" >
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLinkActive="link-active" pTooltip="{{'feedback' | translate}}"
                        style="text-align: center; background: #6E7F91 !important;">
                        <img src="../../../../assets/img/logos/feedback.png" class="nineImg newImg">
                        <div class="newSpan">{{'feedback' | translate}}</div>  
                    </a>
                </div>
                <div class="onedot col-4 p-0" (click)="opendisplayWhatNew()">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/business-dashboard" routerLinkActive="link-active" pTooltip="{{'whatNew' | translate}}"
                        style="text-align: center;background: #6E7F91 !important;">
                        <img src="../../../../assets/img/logos/new.png" class="nineImg newImg">
                        <div class="newSpan">{{'whatNew' | translate}}</div>  
                    </a>
                </div>
                <div class="onedot col-4 p-0" (click)="opendisplayAbout()">
                    <a class="nav-link newCssLink" (click)="op1.hide();" style="text-align: center;background: #6E7F91 !important;" pTooltip="{{'about' | translate}}">
                        <img src="../../../../assets/img/logos/about.png" class="nineImg newImg">
                        <div class="newSpan">{{'about' | translate}}</div>
                    </a>
                </div>
            </div>

            <div class='row' *ngIf="adminNinedot">
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="gotoDashboard();op1.hide();" routerLinkActive="link-active" pTooltip="{{'home' | translate}}"
                        style="text-align: center;">
                        <img src="../../../../assets/img/logos/home.png" class="nineImg newImg">
                        <div class="newSpan">{{'home' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/projects" style="text-align: center;"  pTooltip="{{'projects' | translate}}">
                        <img src="../../../../assets/img/logos/projects.png" class="nineImg newImg">
                        <div class="newSpan">{{'projects' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/users" routerLinkActive="link-active"  pTooltip="{{'users' | translate}}"
                        style="text-align: center; ">
                        <img src="../../../../assets/img/logos/users.png" class="nineImg newImg">
                        <div class="newSpan">{{'users' | translate}}</div>
                    </a>
                </div>

            </div>


            <div class='row' *ngIf="adminNinedot">
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/products" routerLinkActive="link-active" pTooltip="{{'products' | translate}}"
                        style="text-align: center;">
                            <img src="../../../../assets/img/logos/products.png" class="nineImg newImg">
                            <div class="newSpan">{{'products' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/task-status" style="text-align: center;" pTooltip="{{'taskStatus' | translate}}">
                        <img src="../../../../assets/img/logos/taskStatus.png" class="nineImg newImg">
                        <div class="newSpan">{{'taskStatus' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/admin-list" style="text-align: center; " pTooltip="{{'list' | translate}}">
                        <img src="../../../../assets/img/logos/list.png" class="nineImg newImg">
                        <div class="newSpan">{{'list' | translate}}</div>
                    </a>
                </div>

                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/task-type" style="text-align: center; " pTooltip="{{'taskType' | translate}}">
                        <img src="../../../../assets/img/logos/taskType.png" class="nineImg newImg">
                        <div class="newSpan">{{'taskType' | translate}}</div>
                    </a>
                </div>

                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/profile" style="text-align: center; " pTooltip="{{'profiles' | translate}}">
                        <img src="../../../../assets/img/logos/profiles.png" class="nineImg newImg">
                        <div class="newSpan">{{'profiles' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/user-group" style="text-align: center; " pTooltip="{{'userGroup' | translate}}">
                        <img src="../../../../assets/img/logos/userGroup.png" class="nineImg newImg">
                        <div class="newSpan">{{'userGroup' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/user-role" style="text-align: center;"  pTooltip="{{'userRole' | translate}}">
                        <img src="../../../../assets/img/logos/userRole.png" class="nineImg newImg">
                        <div class="newSpan">{{'userRole' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0"> 
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/configuration" style="text-align: center; " pTooltip="{{'configuration' | translate}}">
                        <img src="../../../../assets/img/logos/configuration.png" class="nineImg newImg">
                        <div class="newSpan">{{'configuration' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/audit-log" style="text-align: center;" pTooltip="{{'auditLog' | translate}}">
                        <img src="../../../../assets/img/logos/auditLog.png" class="nineImg newImg">
                        <div class="newSpan">{{'auditLog' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/payments" style="text-align: center;"  pTooltip="{{'manageLicenses' | translate}}">
                        <img src="../../../../assets/img/logos/manageLicenses.png" class="nineImg newImg">
                        <div class="newSpan">{{'manageLicenses' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/invoices" style="text-align: center;"  pTooltip="{{'invoices' | translate}}">
                        <img src="../../../../assets/img/logos/invoices.png" class="nineImg newImg">
                        <div class="newSpan">{{'invoices' | translate}}</div>
                    </a>
                </div>
                <div class="onedot col-4 p-0">
                    <a class="nav-link newCssLink" (click)="op1.hide();" routerLink="/priority" style="text-align: center;"  pTooltip="{{'priority' | translate}}">
                        <img src="../../../../assets/img/priority_nine_dots.png" class="nineImg newImg">
                        <div class="newSpan">{{'priority' | translate}}</div>
                    </a>
                </div>
            </div>
        </p-overlayPanel>
        <p-overlayPanel class="profileOverlay" #opProfile [dismissable]="true" #profile>
            <div class='row'>
                <div class="onedots col-12 p-0" (click)="openFPForm();opProfile.hide()">
                    <div class="displayInlineBlock"> <img src="../../../../assets/img/Group 8484.png"
                            class="displayInlineBlock smallIcon">
                        <p class="displayInlineBlock">
                            {{'editProfilePicture' | translate}}
                        </p>
                    </div>
                </div>
            </div>
            <div class='row'>
                <div class="onedots col-12 p-0" (click)="changePassword();opProfile.hide()">
                    <div class="displayInlineBlock"> <img src="../../../../assets/img/Layer 10.png"
                            class="displayInlineBlock smallIcon">
                        <p class="displayInlineBlock">
                            {{'changePassword' | translate}}
                        </p>
                    </div>
                </div>
            </div>
            <div class='row'>
                <div class="onedots col-12 p-0" (click)="opendisplayAccount();opProfile.hide()">
                    <div class="displayInlineBlock"> <img src="../../../../assets/img/Path 18158.png"
                            class="displayInlineBlock smallIcon">
                        <p class="displayInlineBlock">
                            {{'myAccount' | translate}}
                        </p>
                    </div>
                </div>
            </div>
            <div class='row'>
                <div class="onedots col-12 p-0" (click)="logOut();opProfile.hide()">
                    <div class="displayInlineBlock"> <img src="../../../../assets/img/Group 8530.png"
                            class="displayInlineBlock smallIcon">
                        <p class="displayInlineBlock">
                            {{'logout' | translate}}
                        </p>
                    </div>
                </div>
            </div>

        </p-overlayPanel>
        <!-- Navbar links -->
        <div class="collapse navbar-collapse" id="collapsibleNavbar">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <a class="nav-link">
                        <div class="business">
                            <img class="profileImg"
                                [src]="bussinessLogo? bussinessLogo:'../../../../assets/img/noBLogo.png'" alt="">

                            <div class="busineesDev">
                                <p class="paraBusiness">
                                    <!-- right -->
                                    {{bussinessData?.businessName}}</p>
                                <p class="businessIdData">Business ID:
                                    <span class="idValue">{{bussinessData?.businessId}}</span>

                                </p>
                            </div>
                        </div>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link">
                        <div class="business">
                            <span class="dateDiv">
                                <p id="date">{{todayDate | date: 'dd'}}</p>
                            </span>
                            <div class="idDate">
                                <p class="idDateValue">
                                    <!-- right -->
                                    {{todayDate | date: 'MMMM'}}</p>
                                <p class="idDateDay">
                                    {{todayDate | date: 'EEEE'}}
                                </p>
                            </div>
                        </div>
                    </a>
                </li>
                <li class="nav-item">
                    <p-dropdown [options]="languageDropdown" [(ngModel)]="selectedLanguage" optionLabel="name" placeholder="Select language" class="mr-2 langDropdown" (onChange)="changeLanguage(selectedLanguage.code)">
                        <ng-template pTemplate="selectedItem">
                            <div class="country-item country-item-value"  *ngIf="selectedLanguage">
                                <img *ngIf="selectedLanguage.code=='en'" [src]="languageImage[0]">
                                <img *ngIf="selectedLanguage.code=='es'" [src]="languageImage[1]">
                                <img *ngIf="selectedLanguage.code=='hi'" [src]="languageImage[2]">
                                <img *ngIf="selectedLanguage.code=='fr'" [src]="languageImage[3]">
                                <img *ngIf="selectedLanguage.code=='pr'" [src]="languageImage[4]">
                                <span class="ml-2">{{selectedLanguage.name}}</span>
                            </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                            <div class="country-item" >
                                <img *ngIf="country.value.code=='en'" [src]="languageImage[0]">
                                <img *ngIf="country.value.code=='es'" [src]="languageImage[1]">
                                <img *ngIf="country.value.code=='hi'" [src]="languageImage[2]">
                                <img *ngIf="country.value.code=='fr'" [src]="languageImage[3]">
                                <img *ngIf="country.value.code=='pr'" [src]="languageImage[4]">
                                <span class="ml-2">{{country.value.name}}</span>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </li>
                <li class="nav-item align-self-center">
                    <a class="nav-link  pr-0">
                        <img class="pointer" src="../../../../assets/img/ninedots_new.png" style="width: 20px;"
                            (click)="op1.toggle($event)">
                    </a>
                </li>
                <li class="nav-item align-self-center pr-0">
                    <a class="nav-link notification-overlay pr-0">
                        <div class="buttonData"> <!--  (click)="getAllNotificationLastseen()" -->
                            <img src="../../../../assets/img/Group 3835.png" style="cursor: pointer;" alt="notification"
                                class="bellIcon" (click)="op4.toggle($event)">
                            <span class="button__badge"
                                *ngIf="notifcationCountCondition">{{ this.notificaitonCount.Total}}</span>
                        </div>
                        <p-overlayPanel #op4 [dismissable]="true">
                            <div style="height: 400px;overflow: scroll;overflow-x: hidden">
                                <div class='row' *ngFor="let notification of notificaitonList;  let i=index">
                                    <div class="onedots col-12 p-0" style="margin-left: 15px !important" *ngIf="notification.actionTaken != null">
                                        <div class="displayInlineBlock" style="margin-left: 5px !important">
                                            <p class="displayInlineBlock" >
                                                {{notification.actionTaken}}
                                            </p>
                                            <i class="pi pi-times" style="position: absolute;
                                            right: 36px;font-size: 16px;" (click)="closeNotification(i)"></i>
                                        </div>
                                    </div>
                                </div>
                                <div style="text-align: center">
                                    <p (click)="clearallNotification()" class="clearAll">{{'clearAll' | translate}}</p>
                                </div>
                                <div *ngIf="notificaitonListdata==false">
                                </div>
                            </div>
                        </p-overlayPanel>
                    </a>
                </li>
                <li class="nav-item align-self-center">
                    <a class="nav-link name">
                        {{userPData?.firstname}}
                    </a>
                </li>
                <li class="nav-item" dropdown>
                    <a class="nav-link profileC" dropdownToggle (click)="false" id="    ">
                        <img class="profileImg pointer" [src]="profileSrc? profileSrc:'../../../assets/img/profile.jpg'"
                            alt="" (click)="op2.toggle($event)">
                    </a>
                    <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu p-lg-2 p-md-1" role="menu"
                        aria-labelledby="basic-link">
                        <li class="pointer">
                            <label for="profile-input" style="cursor: pointer;">
                                <i class="fa fa-user" aria-hidden="true"></i>
                                {{'changeProfilePicture' | translate}}
                            </label>
                            <input class="addProfileLogo" style="display: none;" id="profile-input" type="file"
                                accept="image/*" />
                        </li>

                        <li class="pointer pb-1">
                            <i class="fa fa-lock pointer" aria-hidden="true"></i>
                            {{'changePassword' | translate}}
                        </li>
                        <li class="pointer">
                            <i class="fa fa-power-off pointer" aria-hidden="true"></i>
                            {{'logout' | translate}}
                        </li>
                    </ul>

                    <p-overlayPanel #op2 [dismissable]="true">
                        <div class='row'>
                            <div class="onedots col-12 p-0" (click)="openFPForm();op2.hide()">
                                <div class="displayInlineBlock"> <img src="../../../../assets/img/Group 8484.png"
                                        class="displayInlineBlock smallIcon">
                                    <p class="displayInlineBlock">
                                        {{'editProfilePicture' | translate}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class='row'>
                            <div class="onedots col-12 p-0" (click)="changePassword();op2.hide()">
                                <div class="displayInlineBlock"> <img src="../../../../assets/img/Layer 10.png"
                                        class="displayInlineBlock smallIcon">
                                    <p class="displayInlineBlock">
                                        {{'changePassword' | translate}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class='row'>
                            <div class="onedots col-12 p-0" (click)="opendisplayAccount();op2.hide()">
                                <div class="displayInlineBlock"> <img src="../../../../assets/img/Path 18158.png"
                                        class="displayInlineBlock smallIcon">
                                    <p class="displayInlineBlock">
                                        {{'myAccount' | translate}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class='row'>
                            <div class="onedots col-12 p-0" (click)="logOut();op2.hide()">
                                <div class="displayInlineBlock"> <img src="../../../../assets/img/Group 8530.png"
                                        class="displayInlineBlock smallIcon">
                                    <p class="displayInlineBlock">
                                        {{'logout' | translate}}
                                    </p>
                                </div>
                            </div>
                        </div>

                    </p-overlayPanel>

                </li>
            </ul>
        </div>
        </div>
    </nav>
    <p-breadcrumb [model]="breadCrumb"></p-breadcrumb>
</div>

<!-- Edit Profile Picture -->
<p-dialog header="{{'attachFile' | translate}}" [(visible)]="displayFP" styleClass="overlayDialog" [modal]="true"
    [style]="{width: '500px', height: 'auto'}" [draggable]="false">
    <div class="fp-form-wrap p-5">
        <form [formGroup]="forgetPassForm">
            <div class="form-group files">
                <input (change)="onProfilePicChange($event)" type="file" #fileInput class="form-control fileCss"
                    formControlName="file" [multiple]="false">
                <label class="fileSizeLabel mb-0"><span class="text-danger">*</span> {{'fileGreater500kb' | translate}}</label>
            </div>
            <div class="row">
                <button  pButton label="{{'deleteProfilePicture' | translate}}" (click)="removeuserLogo(email)" class="profileButton2" 
                [disabled]="profileSrc=='data:image/png;base64,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'"></button>
                <button pButton label="{{'addBtn' | translate}}" [disabled]="forgetPassForm.invalid" class="profileButton" (click)="uplaodProfile()" *ngIf="lang=='en'"></button>
                <button pButton label="{{'cancelSmallCaps' | translate}}" class="profileButton" (click)="openFPForm()" *ngIf="lang=='en'"></button>
                <button pButton label="{{'removeImage' | translate}}" [disabled]="forgetPassForm.invalid" class="profileButton" (click)="resetPassForm()" *ngIf="lang=='en'"></button>
                <button pButton label="{{'addBtn' | translate}}" [disabled]="forgetPassForm.invalid" class="profileButton" (click)="uplaodProfile()" *ngIf="lang!='en'" style="width: auto !important;"></button>
                <button pButton label="{{'cancelSmallCaps' | translate}}" class="profileButton" (click)="openFPForm()" *ngIf="lang!='en'" style="width: auto !important;"></button>
                <button pButton label="{{'removeImage' | translate}}" [disabled]="forgetPassForm.invalid" class="profileButton" (click)="resetPassForm()" style="width: auto !important;" *ngIf="lang!='en'"></button>
            </div>
        </form>
    </div>
</p-dialog>

<!-- My Account -->
<p-dialog header="{{'myAccount' | translate}}" [(visible)]="displayAccount" (onHide)="onCancelAccount()"
    styleClass="overlayDialogAccount" [modal]="true" [style]="{width: '670px', height: 'auto'}" [draggable]="false">
    <div class="row pl-4">
        <div class="col-lg-5 col-md-5 col-sm-5 col-5">
            <div class="productActiveD">
                <p class="productAcivateHeadline"><b>{{'userInformation' | translate}}</b></p>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3 col-3">
                    <img class="profileImg pointer" [src]="profileSrc? profileSrc:'../../../assets/img/profile.jpg'" style="width: 43px;">
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-3" style="padding-left: 0px;">
                    <p>
                        <b>{{userPData?.firstname}}</b> 
                    </p>
                    <p *ngIf="userDataCheck">
                        {{userData?.emailId}}
                    </p>
                </div>
            </div>
            <div style=" margin-left: 11px;margin-top: 15px;line-height: 0;"><label style="color:black;">{{'preferredLanguage' | translate}} : <span style="font-weight: 600;font-size: 14px !important;" *ngIf="selectedLanguage">{{selectedLanguage.name}}</span></label></div>
            <div style="color: blue;margin-top: 1px;cursor: pointer; margin-left: 11px;" (click)="openFPForm()">{{'changePhoto' | translate}}</div>
            <div style="color:blue;cursor: pointer;margin-left: 11px;" (click)="logOut()">{{'signOut' | translate}}</div>
        </div>
    </div>
</p-dialog>

<!-- About -->
<p-dialog header="{{'about' | translate}}" [(visible)]="displayAbout" (onHide)="onCancelAbout()" styleClass="overlayDialogAbout"
    [modal]="true" [style]="{width: '670px', height: 'auto'}" [draggable]="false">
    <div>
        <h1 class="aboutProduct" translate>prdInformation</h1>
    </div>
    <div> <img src="../../../../assets/img/My TaskEasy Logo blue.png" alt="Logo" class="productBlue"></div>
    <div class="productActiveD">
        <p class="productAcivate"><b translate>prductActivated</b></p>
        <p class="productAcivateNames">{{'myTaskEasy' | translate}}</p>
        <p class="productAcivateNames">{{'version' | translate}}</p>
    </div>
   <div class="productActiveAccount"> 
       <img src="../../../../assets/img/Group 8680.png" alt="Logo" class="productQuestion">
    </div>
    <div class="productActiveAccount">
        <p class="productAcivate"><b>{{'myTaskEasyUpdates' | translate}}</b></p>
        <p class="productAcivateDesc">{{'updatesProductReadyInstall' | translate}}</p>
    </div>
    <div class="productActiveAccount"> 
        <img src="../../../../assets/img/Straviso-Logo.png" alt="Logo" class="productQuestion">
    </div>
    <div class="productActiveAccount">
        <p class="productAcivate"><b>{{'myTaskEasy' | translate}}</b></p>
        <p class="productAcivateDesc">{{'learnmyTaskEasyCopyrightInformation' | translate}}</p>
    </div>
</p-dialog>

<!-- Contact Support -->
<p-dialog header="{{'contactSupport' | translate}}" #op4 [(visible)]="displayContactSupport" (onHide)="onCancelContact()"
    styleClass="overlayDialogAbout" [modal]="true" [style]="{width: '400px', height: 'auto'}" [draggable]="false">
    <p class="TextSmsContact">{{'supportMsg' | translate}}</p>
    <div class="productActiveAboutContact"> 
        <img src="../../../../assets/img/SMS.png" alt="Logo" class="productQuestionsContact">
    </div>
    <div class="productActiveAboutNewContact">
        <p class="productAcivate"><b translate>chatMsg </b></p>
        <p class="productAcivateDescs">{{'straviso' | translate}}</p>
    </div><br>
    <div class="productActiveAboutContact"> 
        <img src="../../../../assets/img/Email.png" alt="Logo" class="productQuestionsContact">
    </div>
    <div class="productActiveAboutNewContact3">
        <p class="productAcivate"><b>{{'supportEmail' | translate}}</b></p>
        <p class="productAcivateDescs">Ticket@NorthStar.StraViso.net</p>
    </div><br>
    <div class="productActiveAboutContact"> 
        <img src="../../../../assets/img/Chat.png" alt="Logo" class="productQuestionsContact">
    </div>
    <div class="productActiveAboutNewContact2">
        <p class="productAcivate"><b translate>smsNumber</b></p>
        <p class="productAcivateDescs">(817)587-4555</p>
    </div><br>
    <div class="productActiveAboutContact pointer" (click)="createTicketSidebar=true;onCancelContact()">
        <img src="../../../../assets/img/createTicket.png" alt="Logo" class="productQuestionsContact pointer">
    </div>
    <div class="productActiveAboutNewContact2">
        <p class="productAcivate"><b translate>createSupportTkt</b></p>
    </div>
</p-dialog>

<!-- Create Ticket Form -->
<p-dialog header="{{'createTicket' | translate}}" [(visible)]="createTicketSidebar" styleClass="overlayDialogAbout" [modal]="true"
    [style]="{width: '600px', height: 'auto'}" [draggable]="false">
    <form [formGroup]="createTicketForm" (ngSubmit)="createTicket(createTicketForm.value)">
        <div class="wrapper">
            <div class="form-group form-inline taskName">
                <input type="text" pInputText class="form-control taskNameInput ng-dirty ng-invalid" id="usr"
                    maxlength="70" [class.invalid]="!createTicketForm.valid" placeholder="{{'addSubject' | translate}}*"
                    formControlName="subject" name="subject">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-6">
                        <div class="">
                            <p class="commonhead commonBottom">{{'businessId' | translate}}</p>
                            <input type="text" class="form-control" formControlName="businessId" name="businessId"
                                disabled=true>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="">
                            <p class="commonhead commonBottom" >{{'businessName' | translate}}</p>
                            <input type="text" class="form-control" formControlName="businessName" name="businessName"
                                disabled=true>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="">
                            <p class="commonhead commonBottom">{{'businessEmail' | translate}}</p>
                            <input type="text" class="form-control" formControlName="emailId" name="emailId"
                                disabled=true>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="">
                            <p class="commonhead commonBottom">{{'selectPriority' | translate}}</p>
                            <p-dropdown [options]="priority" ui-dropdown-filter='' placeholder="{{'selectPriority' | translate}}"
                                optionLabel="name" styleClass="widthdropdownPriority" formControlName="priority">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="editor">
            <p class="commonhead commonBottom">{{'description' | translate}} *</p>
            <p-editor formControlName="description" name="description" [style]="{'height':'98px'}"
                styleClass="editorCreateTask">
            </p-editor>
        </div>
        <div class="editor" style="margin-top: 5px;">
            <p class="commonhead commonBottom">{{'attach' | translate}}</p>
            <input #file style='display: none;' type="file" (change)="onFileChange($event)" formControlName="file"
                name="file">
            <button type="button" (click)="file.click()">{{'chooseFile' | translate}}</button>
            <p>{{files[0]?.name}}</p>
        </div>
        <div class="row pl-12">
            <div class="col-lg-7 col-md-7 col-sm-7 ">
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 " style="height:168px;">
                <button type="button" class="btn btn-default submitBtns" style="position: absolute;right: 162px;bottom: 0;" (click)="cancelCreateTicket()">{{'cancel ' | translate}}</button>
                <input type="submit" class="btn btn-default submitBtn " value="{{'createBTN' | translate}}"
                    [disabled]="!createTicketForm.valid" style="margin-right: 15px;position: absolute;right:48px;cursor: pointer;bottom: 0;">
            </div>
        </div>
    </form>
</p-dialog>

<!-- What's new -->
<p-dialog header="{{'whatNew' | translate}}" [(visible)]="displayWhatNew" styleClass="overlayDialogwhastNew" [modal]="true"
    [style]="{width: '495px', height: 'auto'}" [draggable]="false">
    <div>
        <h1 class="orange">{{'newFeatures' | translate}}</h1>
    </div>
    <div>
        <p class="marginBottom">{{'newFilterOptions' | translate}}</p>
    </div>
    <div>
        <p class="marginBottom">{{'optionSaveFavCustomReports' | translate}} </p>
    </div><div class="productActiveAbout"> 
        <img src="../../../../assets/img/Straviso-Logo.png" alt="Logo" class="productQuestions">
    </div>
    <div class="productActiveAboutNew">
        <p class="productAcivate"><b>{{'myTaskEasy' | translate}}</b></p>
        <p class="productAcivateDescs">{{'version' | translate}}</p>
    </div>
</p-dialog>

<!-- feedback -->
<p-dialog [(visible)]="displayFeedback" styleClass="overlayDialogFeedback" [modal]="true"
    [style]="{'color':'red',width: '356px', height: 'auto'}" [draggable]="false">
    <form [formGroup]="feedbackForm">
        <div class="form-group">
            <h1 class="centerClassRate">{{'rateUs' | translate}} </h1>
            <p class="centerClassp">{{'rateFeedbackMsg' | translate}}</p>
            <p-rating class="form-control" formControlName="feedbackRate" class="centerClass"
                [(ngModel)]="feedbackValue" (onRate)="handleRate($event)" [cancel]="false"
                (onCancel)="handleCancel($event)"></p-rating>
            <p *ngIf="msgCheck" class="centerClassSpan">{{msg}}</p>
            <p *ngIf="!msgCheck" style="visibility: hidden;">valid</p>
            <textarea class="form-control" formControlName="feedbackText" cols="43" rows="7" id="noSpaces" (input)="ChangeFeedbackValue($event)"
                class="feedbacktextarea" required></textarea>
            <div class="invalid-feedback" *ngIf="isValidFeedback==true">{{'feedbackMsg' | translate}}</div>
            <div class="invalid-feedback" *ngIf="isValidFeedback==false" style="visibility: hidden;">{{'feedbackMsg' | translate}}</div>
            <p-footer>
                <button type="submit" (click)="openFormFeedback()" class="btn btn-sm buttonAsLink"
                    [disabled]="feedbackForm.invalid || isValidFeedback==true || !feedbackForm.controls['feedbackText'].value" style="margin-top: 14px;">{{'sendFeedback' | translate}}</button>
                <button type="submit" (click)="openFPFormFeedback()" class="spanLeft cancelAsLink btn btn-sm" style="float: right;margin-right: 10px;
                margin-top: 14px;" *ngIf="lang!='es'">{{'cancelSmallCaps' | translate}}</button>
                <button type="submit" (click)="openFPFormFeedback()" class="spanLeft cancelAsLink btn btn-sm" style="float: right;margin-right: 10px;
                margin-top: -6px;" *ngIf="lang=='es'">{{'cancelSmallCaps' | translate}}</button>
            </p-footer>
        </div>
    </form>
</p-dialog>

<!-- feedback thanks -->
<p-dialog [(visible)]="displayFeedbackThanks" styleClass="overlayDialogFeedback" [modal]="true"
    [style]="{'color':'red',width: '356px', height: 'auto'}" [draggable]="false">
    <!-- appendTo="body" -->

    <h1 class="centerClassT">{{'thankYou' | translate}} !</h1>
    <p class="centerClassp">{{'feedbackSentMsg' | translate}}</p>
    <!-- <p  class="centerClassp">Thank you for using <b>MyTaskEasy!</b></p>       -->

    <p-footer>
        <button type="submit" (click)="openFPFormFeedbackThanks()" class="spanLeftfee btn btn-sm">{{'okBTN' | translate}}</button>
        <!-- <button type="submit"  (click)= "openFormFeedback()"   class="buttonAsLink" [disabled]="feedbackForm.invalid" >Send feedback</button>  -->
    </p-footer>

</p-dialog>

<!-- help -->
<p-dialog [(visible)]="displayFPS" styleClass="overlayDialogHelp" [modal]="true" [position]="position" header="{{'hELP' | translate}}"
    [style]="{width: '30vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" (onHide)="removeHelp()">
    <p-toast [style]="{marginTop: '80px'}" position="top-center"></p-toast>
    <div class="help-search">
        <div class="ui-inputgroup" style="  padding-left: 18px;margin-bottom: 10px;margin-top: 12px;">
            <span class="backiconHelp" (click)="removeHelp()"><i class="pi pi-arrow-left" style="color: #beb3b3;"></i></span>
            <span class="homeiconHelp" (click)="goToHomeHelp()"><i class="pi pi-home" style="color: #beb3b3;"></i></span>
            <span class="searchSpan">
                <img src="../../../../assets/img/searchiconhelp.png" class="helpsearchicon">
                <input placeholder="{{'globalSearch' | translate}}" class="searchBar" type="text" [(ngModel)]="helpText"
                    (ngModelChange)="searchValues(helpText)">
            </span>
            <span style="margin-left: 5px;">
                    <button class="btn btn-sm qrefbtn " (click)="downloadQuickRefPdf()" translate>quickRefGuide</button>
            </span>
        </div>
    </div>
    <p-accordion [expandIcon]="expandIcon" [collapseIcon]="collapseIcons" (onOpen)="onTabOpen1($event)" [(activeIndex)]="tabindex">
        <p-accordionTab>
            <p-header style="cursor: pointer;"><span style="margin-left: 9px;" translate>index</span><span class="ml-3" *ngIf="helpText"> {{'Search Results Found' | translate}} ({{guideResponseNewData.length}}) </span>   </p-header>
            <p-scrollPanel [style]="{ height: '400px'}" styleClass="mystyle">
                <div *ngIf="!helpText">
                    <div  *ngFor="let faq of guideResponseNew; let indexofEle=index">
                        <div>
                            <p class="faqPara" (click)="openDetails(indexofEle,faq.subHeadingName)" style="display: inline-block;font-family: Roboto !important;font-size: 15px;cursor: pointer;">
                                <i class="arrow down " *ngIf="faq.subHeadingName == highlightCheck " style="margin-right: 5px;margin-left: 4px;"></i>
                                <i class="arrow right " *ngIf="faq.subHeadingName != highlightCheck " style="margin-right: 5px;margin-left: 4px;"></i>
                                <b>{{faq.subHeadingName}}</b> 
                            </p>
                        </div>     
                        <div *ngIf="showDetails == indexofEle " style="margin-left: 30px;padding: 0px">
                            <div *ngFor="let faqHelpNew of faq.helpTopics;let indexofElesNew=index;"  >
                                <span style="display: inline-block">
                                    <p class="faqPara hovera"  (click)="openDetailsHelpItemHeadingNew(indexofElesNew,faqHelpNew.topicName,faqHelpNew.answer)" style="display: list-item;font-size: 14px;cursor: pointer;">
                                        <i class="arrow down " *ngIf="faqHelpNew.topicName == highlightCheckHelpHeadingNew " style="margin-right: 5px;margin-left: 4px;"></i>
                                        <i class="arrow right " *ngIf="faqHelpNew.topicName != highlightCheckHelpHeadingNew " style="margin-right: 5px;margin-left: 4px;"></i>
                                        <b style="display: inline-block;"   style="font-family: Roboto !important;">{{faqHelpNew.topicName}}</b>
                                    </p>
                                </span>
                                <div  *ngIf="showDetailsHelpHeadingNew == indexofElesNew && highlightCheckHelpHeadingNew == faqHelpNew.topicName" style="margin-left: 30px;padding: 0px">
                                    <p  style="padding-left: 20px" ><b style="font-family: Roboto !important; font-size: 13px;" [innerHTML]="faqHelpNew.answer"></b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="helpText"> 
                    <div *ngFor="let faqHelp of guideResponseNewData;let indexofEles=index;"  >
                        <span style="display: inline-block;width: 280px">
                                <p class="faqPara hovera"  (click)="openDetailsHelpItem(indexofEles,faqHelp.topicName,faqHelp.answer)" style="display: list-item;font-size: 14px;cursor: pointer;">
                                    <i class="arrow down " *ngIf="faqHelp.topicName == highlightCheckHelp " style="margin-right: 5px;margin-left: 4px;"></i>
                                    <i class="arrow right " *ngIf="faqHelp.topicName != highlightCheckHelp " style="margin-right: 5px;margin-left: 4px;"></i>
                                <b style="display: inline-block;"  style="font-family: Roboto !important;">{{faqHelp.topicName}}</b>
                            </p>         
                        </span><div *ngIf="showDetailsHelp == indexofEles && newValueCheck == faqHelp.answer ">
                                <p style="padding-left: 20px;font-family: Roboto !important;"><b style="font-family: Roboto !important; font-size: 13px;" [innerHTML]="faqHelp.answer"></b></p>
                            </div> ​
                    </div>
                </div>  
            </p-scrollPanel>
        </p-accordionTab>
        <p-accordionTab>
            <p-header  style="cursor: pointer;"><span style="margin-left: 9px;" translate>fAQs</span><span class="ml-3" *ngIf="helpText"> {{'Search Results Found' | translate}} ({{faqResponseNew.length}})</span></p-header>
            <p-scrollPanel [style]="{ height: '400px'}" styleClass="mystyle" >
                <div *ngFor="let faqHelp of  faqResponseNew;let indexofEles=index;">
                    <span style="display: inline-block;width: 280px">
                        <p class="faqPara hovera"  (click)="openDetailsHelpItem(indexofEles,faqHelp.topicName,faqHelp.answer)" style="display: list-item;font-size: 14px;cursor: pointer;">
                            <i class="arrow down " *ngIf="faqHelp.topicName == highlightCheckHelp " style="margin-right: 5px;margin-left: 4px;"></i>
                            <i class="arrow right " *ngIf="faqHelp.topicName != highlightCheckHelp " style="margin-right: 5px;margin-left: 4px;"></i>
                            <b style="display: inline-block;"  style="font-family: Roboto !important;font-weight: 500 !important;">{{faqHelp.topicName}}</b>
                        </p>    
                    </span><div *ngIf="showDetailsHelp == indexofEles && newValueCheck == faqHelp.answer ">
                        <div>
                            <p style="padding-left: 20px;font-family: Roboto !important;"><b style="font-family: Roboto !important; font-size: 13px;" [innerHTML]="faqHelp.answer"></b></p>
                        </div> 
                        <div *ngFor="let img of faqHelp?.imgLink ">
                            <img style="margin-left: 20px;height: 150px;width: 150px;margin-top: 10px;margin-bottom: 10px;margin-right: 8px;"   *ngIf="img"   [src]="img" alt="">
                        </div>
                    </div> ​
                </div>
            </p-scrollPanel>
        </p-accordionTab>
        <p-accordionTab>
            <p-header  style="cursor: pointer;"><span style="margin-left: 9px;" translate>videos</span> <span class="ml-3" *ngIf=" helpText">{{'Search Results Found' | translate}} ({{videoResponseNew.length}})</span></p-header>
            <p-scrollPanel [style]="{ height: '400px'}" styleClass="mystyle">
                <div  *ngFor="let video of videoResponseNew;let indexofEle=index;" style="cursor: pointer;">
                        <img (click)="openVideo(video.answer,video.topicName)"  src="../../../../assets/img/play.png" alt="" style="height: 28px;width: 28px;display: inline-block;cursor: pointer;margin-right: 15px;">    
                        <p class="faqPara" (click)="openVideo(video.answer,video.topicName)" style="font-family: Roboto !important;font-size: 15px;margin-bottom: 5px;display: inline-block;"><b>{{video.topicName}}</b></p>
                </div>
            </p-scrollPanel>
    </p-accordionTab>
    </p-accordion>
</p-dialog>

<!-- video help modal -->
<p-dialog [(visible)]="videoModalHelp" class="textMsgModalHelpVideo" [modal]="true" [baseZIndex]="10000" [draggable]="false" [closeIcon]="false" [showHeader]="true"
    [resizable]="false"  [style]="{width: '1000px', height: 'auto',right:'32%'}"  >
    <p-header>
        <img src="../../../../assets/img/Group 8423.png" class="closeIconVideoCss" (click)="videoModalHelp=false" title="{{'closeVideo' | translate}}">
    </p-header>
        <div class="row m-0">
            <iframe [src]="videoLink | safe" scrolling="no" class="iframeCss"></iframe>
        </div>
        <div class="row m-0" class="videolinkcss"><a [href]="videoLink" target="_blank" class="" style="font-size: 17px;"><span (click)="removeHelp()"><i class="fa fa-expand"></i></span></a></div>
</p-dialog>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>




